<!-- Manual re-print button shown after card loads, hidden in @media print -->
<div class="print-btn-wrap" *ngIf="cardLoaded">
  <button class="print-btn" (click)="printPage()">
    <svg class="print-btn-icon" width="18" height="18" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
      <path fill="currentColor" d="M17.9949367,13.8965306 L17.9949367,7.62734694 C17.9949367,6.83979592 17.3704641,6.19795918 16.6042194,6.19795918 L14.9299578,6.19795918 L14.9299578,2.91938776 C14.9299578,2.41285714 14.52827,2 14.035443,2 L5.96455696,2 C5.47172996,2 5.07004219,2.41285714 5.07004219,2.91938776 L5.07004219,6.19795918 L3.39578059,6.19795918 C2.62953586,6.19795918 2.00506329,6.83979592 2.00506329,7.62734694 L2.00506329,13.8965306 C2.00506329,14.6840816 2.62953586,15.3259184 3.39578059,15.3259184 L5.07004219,15.3259184 L5.07004219,18.0806122 C5.07004219,18.5871429 5.47172996,19 5.96455696,19 L14.035443,19 C14.52827,19 14.9299578,18.5871429 14.9299578,18.0806122 L14.9299578,15.322449 L16.6042194,15.322449 C17.3738397,15.322449 17.9949367,14.6840816 17.9949367,13.8965306 Z M5.73839662,2.91938776 C5.73839662,2.79102041 5.83966245,2.68693878 5.96455696,2.68693878 L14.035443,2.68693878 C14.1603376,2.68693878 14.2616034,2.79102041 14.2616034,2.91938776 L14.2616034,6.19795918 L5.73839662,6.19795918 L5.73839662,2.91938776 Z M14.2649789,18.0806122 C14.2649789,18.2089796 14.1637131,18.3130612 14.0388186,18.3130612 L5.96455696,18.3130612 C5.83966245,18.3130612 5.73839662,18.2089796 5.73839662,18.0806122 L5.73839662,11.1071429 L14.2616034,11.1071429 L14.2616034,18.0806122 L14.2649789,18.0806122 Z M17.3265823,13.8965306 C17.3265823,14.3059184 17.0025316,14.6389796 16.6042194,14.6389796 L14.9299578,14.6389796 L14.9299578,10.7636735 C14.9299578,10.5728571 14.7814346,10.4202041 14.5957806,10.4202041 L5.40421941,10.4202041 C5.2185654,10.4202041 5.07004219,10.5728571 5.07004219,10.7636735 L5.07004219,14.6389796 L3.39578059,14.6389796 C2.99746835,14.6389796 2.67341772,14.3059184 2.67341772,13.8965306 L2.67341772,7.62734694 C2.67341772,7.21795918 2.99746835,6.88489796 3.39578059,6.88489796 L16.6042194,6.88489796 C17.0025316,6.88489796 17.3265823,7.21795918 17.3265823,7.62734694 L17.3265823,13.8965306 L17.3265823,13.8965306 Z"/>
      <path fill="currentColor" d="M4.3814346,8.30040816 C4.29367089,8.30040816 4.2092827,8.33857143 4.14514768,8.40102041 C4.08438819,8.46693878 4.04725738,8.55367347 4.04725738,8.64387755 C4.04725738,8.73408163 4.08438819,8.82081633 4.14514768,8.88673469 C4.2092827,8.94918367 4.29367089,8.98734694 4.3814346,8.98734694 C4.46919831,8.98734694 4.5535865,8.94918367 4.61772152,8.88673469 C4.67848101,8.82428571 4.71561181,8.73408163 4.71561181,8.64387755 C4.71561181,8.55367347 4.67848101,8.46693878 4.61772152,8.40102041 C4.55696203,8.33857143 4.46919831,8.30040816 4.3814346,8.30040816 Z"/>
      <path fill="currentColor" d="M7.63544304,15.0518367 L12.371308,15.0518367 C12.556962,15.0518367 12.7054852,14.8991837 12.7054852,14.7083673 C12.7054852,14.517551 12.556962,14.364898 12.371308,14.364898 L7.63544304,14.364898 C7.44978903,14.364898 7.30126582,14.517551 7.30126582,14.7083673 C7.30126582,14.8991837 7.44978903,15.0518367 7.63544304,15.0518367 Z"/>
      <path fill="currentColor" d="M7.63544304,16.9981633 L12.371308,16.9981633 C12.556962,16.9981633 12.7054852,16.8455102 12.7054852,16.6546939 C12.7054852,16.4638776 12.556962,16.3112245 12.371308,16.3112245 L7.63544304,16.3112245 C7.44978903,16.3112245 7.30126582,16.4638776 7.30126582,16.6546939 C7.30126582,16.8455102 7.44978903,16.9981633 7.63544304,16.9981633 Z"/>
      <path fill="currentColor" d="M7.63544304,13.1055102 L12.371308,13.1055102 C12.556962,13.1055102 12.7054852,12.9528571 12.7054852,12.7620408 C12.7054852,12.5712245 12.556962,12.4185714 12.371308,12.4185714 L7.63544304,12.4185714 C7.44978903,12.4185714 7.30126582,12.5712245 7.30126582,12.7620408 C7.30126582,12.9528571 7.44978903,13.1055102 7.63544304,13.1055102 Z"/>
    </svg>
    Print Card
  </button>
</div>

<div id="printdiv">
  <div style="padding-top: 20px;font-weight:700;color: #27524B;font-size: 20px;">
  {{medicineName}}
  </div>
  <table width="100%" style="max-width:400px;margin-left:auto;margin-right:auto" align="center" class="printcard">
    <tr>
      <td style="padding-top:23px">
        <table width="400" align="center" cellpadding="0" cellspacing="0"
          style="background: #fff;border-radius: 15px;box-shadow: 0 0 12px #ccc;width: 400px;" class="firsttable">
          <tr>
            <td style="padding-left: 15px;padding-bottom: 15px;padding-top: 15px;border-bottom: 2px solid #25534B;">

              <img
                src="../assets/images/header_logo.png"
                width="140" height="" alt="logo.png" title="logo.png">
            </td>
            <td align="right" style="font-family: Roboto;font-size: 13px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: -0.4px;text-align: center;
                            color: #25534B;border-bottom: 2px solid #25534B;">
              Member Support<br>
              <span>(800) 984-4031</span>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <table cellpadding="0" cellspacing="0" style="width: 100%;">
                <tr>
                  <td style="width:50%;min-width:130px;padding-top: 15px;padding-bottom: 15px;padding-left: 30px;font-family: Roboto;font-size: 13px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: -0.4px;text-align: left;
                            color: #FF8B6C;">
                    BIN<br>
                    <span style="font-family: Roboto;font-size: 16px;font-weight: 700;font-stretch: normal;font-style: normal;letter-spacing: -0.4px;text-align: left;
                                color: #27524B;">{{bin}}</span>
                  </td>
                  <td style="width:152px;min-width:50%;padding-top: 15px;padding-bottom: 15px;padding-left: 8px;font-family: Roboto;font-size: 13px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: -0.4px;text-align: left;
                            color: #FF8B6C;">
                    Group # (Access Code)<br>
                    <span style="font-family: Roboto;font-size: 16px;font-weight: 700;font-stretch: normal;font-style: normal;letter-spacing: -0.4px;text-align: left;
                                color: #27524B;">{{groupno_valid}}</span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <table cellpadding="0" cellspacing="0" style="width: 100%;">
                <tr>
                  <td style="width:50%;min-width:130px;padding-top: 0;padding-bottom: 15px;padding-left:30px;font-family: Roboto;font-size: 13px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: -0.4px;text-align: left;
                            color: #FF8B6C;">
                    PCN<br>
                    <span style="font-family: Roboto;font-size: 16px;font-weight: 700;font-stretch: normal;font-style: normal;letter-spacing: -0.4px;text-align: left;
                                color: #27524B;">{{pcn}}</span>
                  </td>
                  <td style="width:50%;min-width:152px;padding-top: 0;padding-bottom: 15px;padding-left: 8px;font-family: Roboto;font-size: 13px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: -0.4px;text-align: left;
                            color: #FF8B6C;">
                    Member ID<br>
                    <span style="font-family: Roboto;font-size: 16px;font-weight: 700;font-stretch: normal;font-style: normal;letter-spacing: -0.4px;text-align: left;
                                color: #27524B">{{memberid}}</span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <table cellpadding="0" cellspacing="0"
                style="width: 100%;background: #27524B;border-radius: 0 0 15px 15px;height: 36px;">
                <tr>
                  <td valign="center"
                    style="font-family: Roboto;font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: -0.4px;text-align: left;
                        color: #fff;padding-left: 8px;width:70%;min-width:70%;max-width:70%;padding-bottom:5px;padding-top:5px;vertical-align:middle;">

                    <p style="margin-top: 0;font-size: 13px;"><span style="font-weight: bold;">This is not insurance.</span> This card is free</p>
                  </td>
                  <td style="width:30%;min-width:30%;max-width:30%;padding-bottom:5px;padding-top:5px">
                    <table cellpadding="0" cellspacing="0" style="width:100%">
                      <tr>
                        <td style="font-family:Roboto;font-size: 12px;font-weight:normal;font-stretch: normal;font-style: normal;letter-spacing: -0.4px;text-align: left;
                                    color: #fff;">
                          Powered By
                        </td>
                      </tr>
                      <tr>
                        <td border="0" style="background:transparent;">
                          <a href="https://glichealth.com/" target="_blank" style="border:none;text-decoration:none"><img border="0"
                              src="http://cdn.mcauto-images-production.sendgrid.net/436e27025ec79248/a6efda1c-e3b6-4e41-aa75-53795612d46c/268x44.png"
                              width="65"
                              style="width: 65px;background:transparent;max-width:65px;border:none;outline:none;border:0"
                              alt=""></a>
                        </td>
                      </tr>
                    </table>

                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>

  <table width="100%" style="max-width:400px;margin-left:auto;margin-right:auto;margin-top:23px" align="center">
    <tr>
      <td>
        <table width="400" align="center" cellpadding="0" cellspacing="0" class="secondtable"
          style="background: #fff;border-radius: 15px;box-shadow: 0 0 12px #ccc;width: 400px;padding-top:10px">

          <tr>
            <td
              style="font-family: Roboto;font-size: 12px;font-weight: normal;padding-top:0;padding-left:15px;padding-bottom:0;min-width:150px;max-width:150px;vertical-align:top;color:#27524B;border-right:1px solid #eee;">

              <p style="padding:0;margin:0;font-size:12px;padding-top: 10px;">Accepted at approx 35,000 pharmacies 
                nationwide</p>
              <p style="padding:0;margin:0;margin-top:5px">
                <img
                  src="http://cdn.mcauto-images-production.sendgrid.net/436e27025ec79248/e6a59532-f2b5-49f2-bea5-b77c14a7836d/130x27.png" alt="">
              </p>
              <p
                style="font-family: Roboto;font-size: 12px;font-weight: normal;padding-top:0;padding-bottom:0;min-width:192px;max-width:192px;vertical-align:top;color:#27524B;border-right:1px solid #eee;">
                For more information, to report
                issues, and to find participating
                pharmacies near you, visit <a href="https://glicrx.com"
                  style="color:#000;font-weight:bold;text-decoration:none;">glicrx.com</a>
                or call <a href="tel:8009844031" style="color:#000;font-weight:bold;text-decoration:none;">(800)
                  984-4031</a>.

              </p>
            </td>
            <td
              style="font-family: Roboto;font-size: 12px;font-weight: normal;padding-top:0;padding-left:15px;padding-bottom:0;min-width:130px;max-width:140px;vertical-align:top;color:#27524B;padding-right:10px;">
              <p style="padding:0;margin:0;font-size: 12px;padding-top: 10px">
                <strong style="color:#000;">Member Instructions</strong><br>
                1. Present card to pharmacist.<br>
                2. Ask for discount on each
                prescription and <strong style="color:#000;">save up to $95!</strong>
              </p>

              <p style="padding:0;margin:0;font-size: 12px;margin-top:8px;">
                <strong style="color:#000;">Pharmacist Instructions</strong><br>
                This card gives holder discounts
                through the BIN, PCN, Group on
                the front. If you need assistance
                call <a href="tel:8778007820" style="color:#000;font-weight:bold;text-decoration:none;">(877)
                  800-7820</a>.

              </p>



            </td>

          </tr>
          <tr>
            <td colspan="2"
              style="font-family: Roboto;font-size: 12px;font-weight: normal;padding-top:0px;padding-left:15px;padding-bottom:10px;min-width:150px;max-width:150px;vertical-align:top;color:#27524B;padding-right:15px;padding-top:10px">
              The GlicRx Program, prices, covered drugs, and pharmacies are
              subject to change. By using this card, you agree to the terms & privacy
              policy found at <a href="https://glicrx.com/terms-and-conditions"
                style="color:#27524B;text-decoration:none;">glicrx.com/terms</a>. Administered by Glic Health LLC,
              One Marina Park Drive, Ste 1410, Boston MA 02210 - (844) 944-4542
              <br><br>
              <p style="font-size:10px">CVS, KROGER, WALMART and WALGREENS logos are trademarks and/or registered
                trademarks of CVS, KROGER, WALMART and WALGREENS, respectively.</p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</div>